import React from 'react'
import { Tooltip } from '@surecompanies/core_components'

export const ErrorTooltipRenderer = (props: any) => {
  const errors = props.data?.errors
  const ignoredFields = props.data?.updates?.ignoredFields ?? {}

  if (!errors) return null

  const visibleErrors = Object.entries(errors).filter(
    ([field]) => !ignoredFields[field]
  )

  if (visibleErrors.length === 0) return null

  const errorKeys = visibleErrors.map(([field]) => field).join(', ')
  const tooltipContent = (
    <div>
      {visibleErrors.map(([, e]: [string, any], index: number) => (
        <div key={index}>{e.errorMessage}</div>
      ))}
    </div>
  )
  return (
    <Tooltip title={tooltipContent} mouseEnterDelay={0.6} placement="topLeft">
      <span style={{ color: 'red', fontWeight: 'bold' }}>{errorKeys}</span>
    </Tooltip>
  )
}
